import {
  AdminOrganization,
  AdminOrganizationReport,
} from '@app/admin/organizations/organization';
import {PaginatedBackendResponse} from '@common/http/backend-response/pagination-response';
import {queryFactoryHelpers} from '@common/http/queries-file-helpers';
import {keepPreviousData, queryOptions} from '@tanstack/react-query';

const get = queryFactoryHelpers.get;

export const adminOrganizationsQueries = {
  invalidateKey: ['admin-organizations'],
  index: (search: Record<string, string> = {}) =>
    queryOptions({
      placeholderData: keepPreviousData,
      queryKey: ['admin-organizations', search],
      queryFn: ({signal}) =>
        get<PaginatedBackendResponse<AdminOrganization>>(
          'admin/organizations',
          search,
          signal,
        ),
    }),
  // the printable Customer details page; under the same root key so the
  // list's invalidations reach it too
  report: (organizationId: number | string) =>
    queryOptions({
      queryKey: ['admin-organizations', `${organizationId}`, 'report'],
      queryFn: ({signal}) =>
        get<AdminOrganizationReport>(
          `admin/organizations/${organizationId}/report`,
          undefined,
          signal,
        ),
    }),
};
